import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

export function LanguageSelector() {
    const { language, setLanguage, languages } = useLanguage();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const current = languages.find(l => l.code === language);

    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    return (
        <div ref={ref} className="relative" data-testid="language-selector">
            <button
                onClick={() => setOpen(!open)}
                className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-sm"
                data-testid="language-selector-btn"
            >
                <span className="text-lg leading-none">{current?.flag}</span>
                <span className="hidden sm:inline text-[#F5ECD7]/80 font-medium">{current?.code.toUpperCase()}</span>
            </button>
            {open && (
                <div className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-xl border border-gray-100 py-1 z-50 min-w-[160px]">
                    {languages.map(lang => (
                        <button
                            key={lang.code}
                            onClick={() => { setLanguage(lang.code); setOpen(false); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm hover:bg-gray-50 transition-colors ${
                                language === lang.code ? 'bg-gray-50 font-semibold text-gray-900' : 'text-gray-600'
                            }`}
                            data-testid={`lang-${lang.code}`}
                        >
                            <span className="text-lg leading-none">{lang.flag}</span>
                            <span>{lang.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
